import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-policy',
  templateUrl: './help-policy.component.html',
  styleUrls: ['./help-policy.component.scss']
})
export class HelpPolicyComponent implements OnInit {
  Company_Name: string;
  Company_Email: string;
  Company_MoblNo: string;
  constructor() { }

  ngOnInit() {
    this.Company_Name = sessionStorage.getItem('ihjt45h45=CompanyName')
    this.Company_Email = sessionStorage.getItem('ihjt45h45=j')
    this.Company_MoblNo = sessionStorage.getItem('ihjt45h45=m');
  }

}
